import Vue from 'vue';
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios';
import GmapVue from 'gmap-vue';
import { store } from "@/store";

Vue.config.productionTip = false

const axiosConfig = {
  baseURL: 'https://app.hustopece-city.cz/zabory/api/',
  timeout: 10000,
  withCredentials: true,
};

export const api = axios.create(axiosConfig);
export const loginApi = axios.create(axiosConfig);

export const defaultApiErrorHandler = err => {
  console.error(err.response, err);
  if (err.response) {
    alert('Nastala chyba:\n'+err.response.data);
  } else {
    alert('Nastala chyba: '+err);
  }
};

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyBbBFPs8L0DlLH3HHwyHhN29GKk9uGsxro', // Google Maps API key
    region: 'CZ',
    language: 'cs',
  },
  autoBindAllEvents: false,
  installComponents: true,
  dynamicLoad: false,
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
